import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const FeaturedSingleContainer = styled.div`
  display: none;
  width: 100vw;
  position: relative;
  height: 160vw;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 4rem !important;

  @media all and (max-width: ${layout.sm}) {
    display: flex;
  }
`

export const FeaturedSingleImage = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 1;

  & > div {
    height: 100%;
  }

  &:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(25,31,40,0) 37%, #000 73%);
    opacity: .6;
  }
`

export const FeaturedSingleText = styled.div`
  position: relative;
  padding: 32px;
  z-index: 1;

  & > h1 {
    color: ${palette.white};
  }
`

export const FeaturedSingleLink = styled.div`
  display: grid;
  margin-top: 2rem;

  & > a {
    min-width: 256px;
  }
`
